import { assetUrl } from "../lib/asset";

const knownKeys = new Set([
  "lady-palm",
  "boston-fern",
  "birdnest-fern",
  "spider-plant",
  "peperomia",
  "calathea",
  "rosemary",
  "basil",
  "mint",
  "calamansi",
  "bougainvillea",
  "pothos",
]);

export function PlantArt({ mediaKey, label }: { mediaKey: string; label: string }) {
  const key = knownKeys.has(mediaKey) ? mediaKey : "peperomia";
  return (
    <div className={`plant-art plant-art-${key}`} role="img" aria-label={`Minh họa ${label}`}>
      <svg viewBox="0 0 160 160" aria-hidden="true" focusable="false">
        <use href={`${assetUrl("/media/botanical-board.svg")}#${key}`} />
      </svg>
    </div>
  );
}
